import { Widgets } from '@mui/icons-material';
import { Box, Button, Card, CardHeader, Grid, LinearProgress, Typography, CardContent, DialogTitle, Chip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Api from '../../Api';
import { IMaterial, IMaterialDispatchDetail } from '../../interfaces';
import './index.scss';
import { NoDetailNotice } from './NoDetailNotice';



const DispatchLineItem: React.SFC<{ detail: IMaterialDispatchDetail, materialId?: string }> = ({ detail, materialId }) => {
    const navigate = useNavigate();
    return (<li >
        <Button variant="text" sx={{ textTransform: 'none' }} onClick={() => {
            navigate('/dispatchrequest/update/' + detail.materialDispatchId);
        }} >
            <Grid container >
                {
                    detail.materialId !== materialId &&
                    <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                        <Widgets /> <Typography sx={{ mr: 4, ml: 1, width: "140px", textAlign: "left" }}> {detail.materialName}</Typography>
                    </Grid>
                }
                <Grid xs={"auto"} display="flex" alignItems="center">
                    <Typography sx={{ mr: 4 }}>{detail.materialDispatchReference}</Typography>
                </Grid>
                <Grid xs={"auto"} display="flex" alignItems="center">
                    <Typography sx={{ mr: 4 }} fontSize="small">{detail.dateCreated ? new Date(detail.dateCreated).toLocaleDateString("en-GB") : ""}</Typography>
                </Grid>
                <Grid xs={"auto"} display="flex" alignItems="center">
                    <Typography sx={{ mr: 4 }}><small>assigned: </small><strong>{detail.dispatchQty}</strong></Typography>
                </Grid>
                <Grid display="flex" alignItems="center">
                    <Chip label={detail.statusName} variant="outlined" />
                </Grid>
            </Grid>
        </Button>
    </li>);

}

export const Dispatches: React.SFC<{ material: IMaterial, load: boolean }> = ({
    load,
    material
}) => {



    const [dispatches, setDispatches] = useState<IMaterialDispatchDetail[]>([]);
    const [storedAssemblyDispatches, setStoredAssemblyDispatches] = useState<IMaterialDispatchDetail[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (material.materialId && load === true)
            Api.Materials.Dispatches.get(material.materialId).then((response: any) => {

                var dispatchDetails = response as IMaterialDispatchDetail[];
                setStoredAssemblyDispatches(dispatchDetails.filter(x => x.storedAssemblyId === material.materialId));
                setDispatches(dispatchDetails.filter(x => x.storedAssemblyId !== material.materialId));

                setLoading(false);

            });
    }, [material.materialId, load])


    useEffect(() => {

    }, [dispatches])

    return (

        (load === false || loading) ? < LinearProgress /> :

            <Grid container>
                <Grid item xs={12}>
                    <Typography className="material-property-text">
                        <strong>Dispatch History</strong>
                    </Typography>
                    <ul className="material-dispatch-list">
                        {dispatches.length === 0 && <NoDetailNotice label="dispatch history" />}
                        {dispatches.map((a, i) => {
                            return <DispatchLineItem
                                materialId={material.materialId}
                                detail={a}
                                key={i}
                            />
                        })}
                    </ul>

                </Grid>
                {
                    storedAssemblyDispatches.length > 0 &&
                    <Grid item xs={12}>
                        <Typography className="material-property-text">
                            <strong>Stored Assembly Dispatch History</strong>
                        </Typography>

                        <ul className="material-dispatch-list">
                            {storedAssemblyDispatches
                                .sort((a, b) => a.materialName.localeCompare(b.materialName))
                                .map((a, i) => {
                                    return <DispatchLineItem
                                        materialId={material.materialId}
                                        detail={a}
                                        key={i} />
                                })}
                        </ul>


                    </Grid>
                }

            </Grid >
    );
}